import React, { useState } from "react";
import { useEffect } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import ProfileMenu from "../../components/ProfileMenu/ProfileMenu";
import profileService from "../../services/profile.service";
import "./ProfileMessages.css";

function ProfileMessages() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const intervalID = setInterval(() => {
      profileService
        .getMessages()
        .then((response) => setMessages(response.data));
    }, 2000);

    return () => {
      clearInterval(intervalID);
    };
  }, []);

  return (
    <Container className="mt-5">
      <Row className=" justify-content-between">
        <Col md={4}>
          <ProfileMenu />
        </Col>
        <Col md={8}>
          {messages.map((message, i) => {
            return (
              <Card className="mb-3" key={i}>
                <Card.Body>
                  <span className="fw-bold">Homie: </span>
                  <p key={i}>{message.livingPlace.title}</p>
                  <span className="fw-bold">Name: </span>
                  <p className="fs-5">{message.name}</p>
                  <span className="fw-bold"> Email: </span>
                  <p>{message.email}</p>
                  <span className="fw-bold"> Phone: </span>
                  <p>{message.phone}</p>
                  <span className="fw-bold"> Message: </span>
                  <p>{message.message}</p>
                </Card.Body>
              </Card>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
}

export default ProfileMessages;
